(function () {
  'use strict';

  var STORAGE_KEY = 'qk_recommended_v1';
  var BADGE_LABEL = 'Recommended For You';
  var BADGE_CLASS = 'qk-rec-badge qk-rec-badge--snize';
  var HANDLED_ATTR = 'data-qk-snize-handled';

  function readMatchSet() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.expiresAt || data.expiresAt < Date.now()) return null;
      var set = Object.create(null);
      if (Array.isArray(data.handles)) {
        for (var i = 0; i < data.handles.length; i++) set[data.handles[i]] = true;
      }
      if (Array.isArray(data.ids)) {
        for (var j = 0; j < data.ids.length; j++) set[String(data.ids[j])] = true;
      }
      return set;
    } catch (e) {
      return null;
    }
  }

  function handleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var href = link.getAttribute('href') || '';
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function idFromCard(card) {
    var id = card.getAttribute('data-original-product-id');
    if (id) return String(id);
    var m = (card.id || '').match(/snize-product-(\d+)/);
    return m ? m[1] : null;
  }

  function badge(card, matchSet) {
    if (card.getAttribute(HANDLED_ATTR) === '1') return;
    var handle = handleFromCard(card);
    var id = idFromCard(card);
    var matched = (handle && matchSet[handle]) || (id && matchSet[id]);
    card.setAttribute(HANDLED_ATTR, '1');
    if (!matched) return;
    var title = card.querySelector('.snize-title');
    if (!title || !title.parentNode) return;
    if (title.parentNode.querySelector(':scope > .qk-rec-badge--snize')) return;
    var pill = document.createElement('span');
    pill.className = BADGE_CLASS;
    pill.textContent = BADGE_LABEL;
    title.parentNode.insertBefore(pill, title);
  }

  function scan(matchSet) {
    var cards = document.querySelectorAll('li.snize-product:not([' + HANDLED_ATTR + '="1"])');
    for (var i = 0; i < cards.length; i++) badge(cards[i], matchSet);
  }

  function start() {
    var matchSet = readMatchSet();
    if (!matchSet) return;
    scan(matchSet);
    if (typeof MutationObserver === 'undefined' || !document.body) return;
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        if (!added || !added.length) continue;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          var hit = (n.matches && n.matches('li.snize-product')) ||
                    (n.querySelector && n.querySelector('li.snize-product'));
          if (hit) {
            scan(matchSet);
            return;
          }
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
